import {createSelector} from "reselect";
import {_isHasSubscription, _isSubscriptionActive, _isTrialWasStarted} from "./user";

const getUser = state => state.user;

export const isTrialAvailable = createSelector(
    [getUser],
    (user) => {
        return !_isHasSubscription(user) && !_isTrialWasStarted(user.userData);
    }
);

export const SUBSCRIPTION_STATE_TRIAL_AVAILABLE = 'SUBSCRIPTION_STATE_TRIAL_AVAILABLE';
export const SUBSCRIPTION_STATE_NOT_ACTIVE      = 'SUBSCRIPTION_STATE_NOT_ACTIVE';
export const SUBSCRIPTION_STATE_CUSTOMER_PORTAL = 'SUBSCRIPTION_STATE_CUSTOMER_PORTAL';
export const SUBSCRIPTION_STATE_TRIAL_USED      = 'SUBSCRIPTION_STATE_TRIAL_USED';

export const getSubscriptionState = createSelector(
    [getUser],
    (user) => {
        if (!_isHasSubscription(user) && !_isTrialWasStarted(user.userData)) {
            return SUBSCRIPTION_STATE_TRIAL_AVAILABLE;
        }

        if (!_isHasSubscription(user) && _isTrialWasStarted(user.userData)) {
            return SUBSCRIPTION_STATE_TRIAL_USED;
        }

        if (_isHasSubscription(user) && !_isSubscriptionActive(user.userData)) {
            return SUBSCRIPTION_STATE_NOT_ACTIVE;
        }

        if (_isSubscriptionActive(user.userData)) {
            return SUBSCRIPTION_STATE_CUSTOMER_PORTAL;
        }

        if (_isTrialWasStarted(user.userData)) {
            return SUBSCRIPTION_STATE_CUSTOMER_PORTAL;
        }

        return SUBSCRIPTION_STATE_CUSTOMER_PORTAL;
    }
)